import { memo, PropsWithChildren } from 'react'

type Props = PropsWithChildren<{}>

const Component = (props: Props) => {
  const { children } = props

  return (
    <div
      className="stats  w-full bordered border-accent-content "
      style={{ backgroundColor: 'rgba(0,0,0,0.05)' }}>
      {children}
    </div>
  )
}
export const StatsContainer = memo(Component)